import { connect } from "react-redux";
import { setFocusedValue } from "../../reducers/crossword/actions";
import { getAlphabet, getShowHints } from "../../reducers/crossword/selectors";
import Keyboard from "./Keyboard";

const mapStateToProps = state => ({
  alphabet: getAlphabet(state),
  hint: getShowHints(state)
});

const mapDispatchToProps = dispatch => ({
  setValue: value => dispatch(setFocusedValue(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Keyboard);



// WEBPACK FOOTER //
// ./src/components/Keyboard/KeyboardContainer.js